import {COLORS} from 'redux/actionTypes';

const initialState = {
	colors: [],
	palettes: [],
	paletteIndex: 0,
	colorSelected: false,
	fetching: false,
	initialised: false
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case COLORS.LOADING: {
			return {
				...state,
				fetching: true
			};
		}
		case COLORS.SET: {
			let {
				palettes,
				index = 0
			} = action.payload;
			if (
				typeof palettes === 'undefined' ||
				palettes.length === 0
			) {
				return {
					...state,
					fetching: false,
					initialised: true
				};
			}
			let colors = [];
			palettes[index].colors.map((color) => {
				colors.push(color);
				return true;
			});

			return {
				...state,
				colors,
				paletteIndex: index,
				palettes,
				colorSelected: colors[0],
				fetching: false,
				initialised: true
			};
		}
		case COLORS.SELECT: {
			let {color} = action.payload;
			let findedColor = false;
			state.colors.map((c) => {
				if (c.color === color) {
					findedColor = c;
				}
				return true;
			})
			return {
				...state,
				colorSelected: findedColor
			};
		}
		case COLORS.ADD: {
			let {color} = action.payload;
			let colors = [...state.colors];
			colors.push(color);

			let palette = [...state.palette];
			palette.push(color.color);

			return {
				...state,
				colors,
				palette,
				colorSelected: state.colorSelected === false ? color : state.colorSelected
			};
		}
		default:
			return state;
	}
};

export default reducer;
